/* @flow */

import * as React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

import OpenPdfButton from '../../../documents/OpenPdfButton'
import { addPxToInput } from '../../../shared'
import type { ConnectedBrand } from '../../../types'
import {
  NAVIGATION_LINK_TYPE_SEARCH,
  NAVIGATION_LINK_TYPE_PAGE,
  NAVIGATION_LINK_TYPE_PAGE_V2,
  NAVIGATION_LINK_TYPE_BESTSELLERS,
  NAVIGATION_LINK_TYPE_FILE_BANK,
  NAVIGATION_LINK_TYPE_CAMPAIGN_PDF,
  NAVIGATION_LINK_TYPE_SPRII,
} from '../../shared'

type WebshopNavigationProps = {
  brand: ConnectedBrand,
  navigationLinks: Array<Object>,
  shopUrl: string,

  navigationFont: string,
  navigationFontColor: string,
  navigationFontHoverColor: string,
  navigationFontSize: number,
  navigationHoverUnderline: boolean,
  navigationSpaceBetweenEach: number,
  navigationUppercase: boolean,
}

const WebshopNavigation = (props: WebshopNavigationProps) => {
  const { brand, navigationLinks, shopUrl } = props

  return (
    <NavigationContainer {...props}>
      <ul className="ul-navigation">
        {navigationLinks.map((link, index) => (
          <li key={index}>
            {(link.type === NAVIGATION_LINK_TYPE_SEARCH ||
              link.type === NAVIGATION_LINK_TYPE_BESTSELLERS) && (
              <NavLink
                to={`${shopUrl}/search/${link.id}`}
                activeClassName="active"
              >
                {link.text}
              </NavLink>
            )}
            {(link.type === NAVIGATION_LINK_TYPE_PAGE ||
              link.type === NAVIGATION_LINK_TYPE_PAGE_V2) && (
              <NavLink
                to={`${shopUrl}/page/${link.settings.page_id}`}
                activeClassName="active"
              >
                {link.text}
              </NavLink>
            )}
            {link.type === 'linesheet' && (
              <NavLink
                to={`${shopUrl}/linesheet/${link.linesheet_public_id}`}
                activeClassName="active"
              >
                {link.text}
              </NavLink>
            )}
            {link.type === NAVIGATION_LINK_TYPE_FILE_BANK && (
              <NavLink to={`/file-bank/${brand.id}`} activeClassName="active">
                {link.text}
              </NavLink>
            )}
            {link.type === NAVIGATION_LINK_TYPE_SPRII && (
              <NavLink
                to={`${shopUrl}/sprii/${link.id}`}
                activeClassName="active"
              >
                {link.text}
              </NavLink>
            )}
            {link.type === NAVIGATION_LINK_TYPE_CAMPAIGN_PDF && (
              <OpenPdfButton
                documentId={link.settings.linesheet_document_id}
                render={({ children, open }) => (
                  <a role="button" onClick={open}>
                    {children}
                  </a>
                )}
              >
                {link.text}
              </OpenPdfButton>
            )}
          </li>
        ))}
      </ul>
    </NavigationContainer>
  )
}

export default WebshopNavigation

const NavigationContainer = styled.nav.attrs({})`
  > ul > li {
    line-height: 1;
    padding: 0;
    margin-right: ${({ navigationSpaceBetweenEach }) =>
      addPxToInput(navigationSpaceBetweenEach || 0)};
  }

  > ul > li > a {
    display: block;
    font-weight: bold;

    color: ${({ navigationFontColor }) => navigationFontColor || '#000000'};

    font-family: ${({ navigationFont }) => navigationFont || 'inherit'};

    font-size: ${({ navigationFontSize }) =>
      addPxToInput(navigationFontSize || 14)};
    line-height: 1.2;

    ${({ navigationUppercase }) =>
      navigationUppercase && 'text-transform: uppercase'};

    &:hover {
      ${({ navigationFontHoverColor }) =>
        navigationFontHoverColor && `color: ${navigationFontHoverColor}`};

      ${({ navigationHoverUnderline }) =>
        navigationHoverUnderline && 'text-decoration:underline'};
    }
  }
`
